










import Vue from 'vue';

import GetResetPassword from '@/web/components/signup/GetResetPassword.vue';

export default Vue.extend({
  name: 'AdminGetResetPassword',
  components: {
    GetResetPassword,
  },
});
